export default {
  state: () => ({
    notifications: [],
    dashboardNotifications: [],
    todayNotifications: [],
    notificationsShown: false,
    outstandingCores: 0,
  }),

  getters: {
    notifications: s => s.notifications,
      dashboardNotifications: s => s.dashboardNotifications,
      todayNotifications: s => s.todayNotifications,
    notificationsShown: s => s.notificationsShown,
    unreadNotifications: s => s.unreadNotifications,
    outstandingCores: s => s.outstandingCores,
  },

  mutations: {
    toggleNotifications(state) {
      state.notificationsShown = !state.notificationsShown
      localStorage.setItem('nova.mainMenu.open', state.notificationsShown)
    },
    setOutstandingCores(state, value) {
      state.outstandingCores = value
    },
  },

  actions: {
    async fetchNotifications({ state }) {
      const {
        data: { notifications, unread, dashboardNotifications, todayNotifications, outstandingCores },
      } = await Nova.request().get(`/nova-api/nova-notifications`)

      state.notifications = notifications
      state.unreadNotifications = unread
      state.dashboardNotifications = dashboardNotifications
      state.todayNotifications = todayNotifications
      state.outstandingCores = outstandingCores
    },

    async markNotificationAsUnread({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/${id}/unread`)
      dispatch('fetchNotifications')
    },

    async markNotificationAsRead({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/${id}/read`)
      dispatch('fetchNotifications')
    },

    async deleteNotification({ state, dispatch }, id) {
      await Nova.request().delete(`/nova-api/nova-notifications/${id}`)
      dispatch('fetchNotifications')
    },

    async deleteAllNotifications({ state, dispatch }, id) {
      await Nova.request().delete(`/nova-api/nova-notifications`)
      dispatch('fetchNotifications')
    },

    async markAllNotificationsAsRead({ state, dispatch }, id) {
      await Nova.request().post(`/nova-api/nova-notifications/read-all`)
      dispatch('fetchNotifications')
    },
  },
}
